import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

@Component({
  selector: 'app-klubi',
  templateUrl: './klubi.component.html',
  styleUrls: ['./klubi.component.scss']
})
export class KlubiComponent implements OnInit {
  clubs: any[] = [];
  filteredClubs: any[] = [];
  search = '';
  loading = false;
  error = '';
  clubDialogOpen = false;
  selectedClub: any = null;

  constructor(private http: HttpClient) {}

  ngOnInit(): void {
    this.loadClubs();
  }

  loadClubs(): void {
    this.loading = true;
    this.error = '';
    this.http.get<any[]>('https://testapi.ovh/api/strelstvo/clubs', {
      headers: this.headers(),
      params: this.unitParams()
    }).subscribe({
      next: clubs => {
        this.clubs = Array.isArray(clubs) ? clubs : [];
        this.applySearch();
        this.loading = false;
      },
      error: error => {
        console.error('Error loading clubs:', error);
        this.clubs = [];
        this.filteredClubs = [];
        this.loading = false;
        this.error = error.error?.error || 'Napaka pri nalaganju klubov.';
      }
    });
  }

  applySearch(): void {
    const search = this.search.trim().toLocaleLowerCase('sl');
    this.filteredClubs = search
      ? this.clubs.filter(club => club.name?.toLocaleLowerCase('sl').includes(search) || String(club.code || '').toLocaleLowerCase('sl').includes(search))
      : [...this.clubs];
  }

  startAdd(): void {
    this.selectedClub = null;
    this.clubDialogOpen = true;
  }

  startEdit(club: any): void {
    this.selectedClub = { ...club };
    this.clubDialogOpen = true;
  }

  cancelEdit(): void {
    this.clubDialogOpen = false;
    this.selectedClub = null;
  }

  onDialogSave(): void {
    this.cancelEdit();
    this.loadClubs();
  }

  private headers(): HttpHeaders {
    const token = localStorage.getItem('access_token');
    return token ? new HttpHeaders({ Authorization: `Bearer ${token}` }) : new HttpHeaders();
  }

  private unitParams(): HttpParams {
    const unitId = localStorage.getItem('unit_id');
    return unitId ? new HttpParams().set('unit_id', unitId) : new HttpParams();
  }
}
